import { provideHttpClient } from '@angular/common/http';
import {
    ApplicationConfig,
    isDevMode,
    provideAppInitializer,
    provideExperimentalZonelessChangeDetection
} from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getRemoteConfig, provideRemoteConfig } from '@angular/fire/remote-config';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { appInitializer } from '@core';
import { environment } from '@env';
import Aura from '@primeng/themes/aura';
import { getFirestore } from 'firebase/firestore';
import { API_BASE_URL } from 'moddy/common';
import { provideHighlightOptions } from 'ngx-highlightjs';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideHttpClient(),
        provideAnimations(),
        provideRouter(routes, withPreloading(PreloadAllModules)),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        provideExperimentalZonelessChangeDetection(),
        provideFirebaseApp(() => initializeApp(environment.firebaseOptions)),
        provideAuth(() => getAuth()),
        provideFirestore(() => getFirestore()),
        provideFunctions(() => getFunctions()),
        provideRemoteConfig(() => {
            const config = getRemoteConfig();

            config.settings.minimumFetchIntervalMillis = isDevMode() ? 0 : 43200000;

            return config;
        }),
        provideAppInitializer(appInitializer),
        provideHighlightOptions({
            coreLibraryLoader: () => import('highlight.js/lib/core'),
            lineNumbersLoader: () => import('ngx-highlightjs/line-numbers'),
            languages: {
                javascript: () => import('highlight.js/lib/languages/javascript'),
                python: () => import('highlight.js/lib/languages/python'),
                json: () => import('highlight.js/lib/languages/json')
            }
        }),
        {
            provide: API_BASE_URL,
            useValue: environment.apiBaseUrl
        },
        MessageService,
        DialogService
    ]
};
